<template>
  <v-card class="align-center">   
    <v-card-title primary-title>
      <div class="text-h4">
        Buntblock         
      </div>
      <v-spacer />         
    </v-card-title>   
   
    <v-container v-if="bundleBlocks.length > 0">
      <v-row v-if="$vuetify.breakpoint.mdAndUp" dense class="ma-1 text-h6 text-uppercase"> 
        <v-col cols="2">
          Typ
        </v-col>
        <v-col cols="2">
          Beställt
        </v-col>
        <v-col cols="2">
          Giltighetsdatum
        </v-col>
        <v-col cols="2">  
          Nummerserie
        </v-col>
        <v-col cols="1">
          Oanvända
        </v-col>      
      </v-row>                      
      <template v-for="(block) in bundleBlocks">
        <BundleBlock :key="block.id" :bundle-block="block" />        
      </template>      
    </v-container>
    <v-container v-else>
      <h3>Inget att rapportera</h3>
    </v-container>       
  </v-card>
</template>

<script>
import log from '@/logger'
import api from '@/backend/api'
import { orderBy} from 'lodash'
import BundleBlock from '@/components/web/BundleBlock'

export default {
  name:'BundleBlocks',
  components:{BundleBlock},
  data(){
    return {
      bundleBlocks:[]
    }
  },
  mounted(){
     api.getBundleBlocks().then(resp => {     
       log.debug('Got bundle blocks ', resp.data)  
          this.bundleBlocks =  orderBy(resp.data.filter(b=>b.numberUnused > 0), ['fromDate'],['desc'])
        })   
  }
}
</script>